import { Link } from "react-router-dom";
import { useQuote } from "@/context/QuoteContext";
import { Button } from "@/components/ui/button";
import TransformationCard from "@/components/TransformationCard";
import { TRANSFORMATIONS } from "@/data/transformations";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Transformations() {
  const { openQuote } = useQuote();
  const { t } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary mb-4" data-testid="transformations-back"><ArrowLeft className="w-4 h-4" /> {t("transforms.back")}</Link>

      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">{t("transforms.eyebrow")}</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">{t("transforms.title")}</h1>
        <p className="text-muted-foreground mt-3">{t("transforms.sub")}</p>
      </div>

      <div className="columns-1 sm:columns-2 lg:columns-3 gap-6" data-testid="transformations-grid">
        {TRANSFORMATIONS.map((item) => <TransformationCard key={item.id} item={item} />)}
      </div>

      <div className="text-center mt-12 rounded-3xl bg-primary/5 border border-primary/10 p-8 max-w-2xl mx-auto">
        <ShieldCheck className="w-8 h-8 text-primary mx-auto" />
        <h3 className="font-heading text-xl font-bold mt-2">{t("transforms.ctaTitle")}</h3>
        <p className="text-muted-foreground mt-1">{t("transforms.ctaSub")}</p>
        <Button className="rounded-full mt-4 px-6" onClick={() => openQuote({ type: "quote" })} data-testid="transformations-quote-btn">{t("common.getMyFreeQuote")}</Button>
      </div>
    </div>
  );
}
